(() => {
  'use strict';
  if (window.RavinAccountWishlistLoaded) return;
  window.RavinAccountWishlistLoaded = true;

  const isAr = document.documentElement.lang.toLowerCase().startsWith('ar');
  const tr = (en,ar) => isAr ? ar : en;
  const SESSION_KEY = 'rva_customer_v1';
  const SILENT_HINT_KEY = 'rva_silent_hint_v1';
  const SILENT_BACKOFF_KEY = 'rva_silent_backoff_v1';
  const PENDING_KEY = 'rvw_pending_intent_v1';
  const PROFILE_URL = '/pages/my-ravin#rva-wishlist';
  const API_QUERY = 'query RavinSavedEdit { customer { id metafield(namespace:"custom",key:"ravin_wishlist") { value } } }';
  const API_MUTATION = 'mutation RavinUpdateSavedEdit($metafields:[MetafieldsSetInput!]!){metafieldsSet(metafields:$metafields){metafields{key value} userErrors{field message}}}';
  const ROOT = document.querySelector('[data-rvw-account]');
  const PRODUCT = document.querySelector('[data-rvw-product]');
  let heart = null;
  let busy = false;
  let apiEndpoint = '';
  let toastTimer = 0;
  let accountLoadCounter = 0;

  function el(tag,cls,text) {
    const result = document.createElement(tag);
    if (cls) result.className = cls;
    if (text !== undefined) result.textContent = String(text);
    return result;
  }
  function safeImage(value) {
    try {
      const url = new URL(String(value || ''),location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname.endsWith('.shopify.com') || url.hostname.endsWith('.shopifycdn.net')) ? url.href : '';
    } catch (_) { return ''; }
  }
  function validHandle(value) { return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value); }
  function parseSaved(value) {
    let data;
    try { data = JSON.parse(value || '{"items":[]}'); } catch(_) { throw new Error('Saved edit data could not be read'); }
    const raw = Array.isArray(data) ? data : data?.items;
    if (!Array.isArray(raw)) throw new Error('Saved edit data was invalid');
    return raw.filter(x=>x && validHandle(x.handle)).slice(0,150).map(x=>({
      handle:x.handle,
      variantId:String(x.variantId || ''),
      title:String(x.title || '').slice(0,220),
      image:String(x.image || '').slice(0,900),
      savedAt:typeof x.savedAt==='string' ? x.savedAt : new Date().toISOString()
    }));
  }
  function session() {
    try {
      const raw = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
      if (!raw || !raw.access || !Number.isFinite(Number(raw.expires)) || Number(raw.expires) < Date.now() + 3000) return null;
      return raw;
    } catch (_) { return null; }
  }
  function canRestoreViaShopify() {
    try {
      const hint=Number(localStorage.getItem(SILENT_HINT_KEY)||0);
      const backoff=Number(localStorage.getItem(SILENT_BACKOFF_KEY)||0);
      const notSuppressed=!backoff || Date.now()-backoff>10*60000;
      if(!notSuppressed)return false;
      if(hint>0 && Date.now()-hint<30*86400000)return true;
      // One-time migration for already open tabs connected before this fix.
      const previous=JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
      return Boolean(previous?.access && Number(previous.expires)>0 &&
        Date.now()-Number(previous.expires)<86400000);

    }catch(_){return false;}
  }
  function restoreForProduct(item) {
    if (!canRestoreViaShopify()) return false;
    queueForSignin(item);
    location.assign(PROFILE_URL);
    return true;
  }
  async function endpoint() {
    if (apiEndpoint) return apiEndpoint;
    const response = await fetch('/.well-known/customer-account-api',{credentials:'omit',cache:'no-store'});
    if (!response.ok) throw Error('Customer account service unavailable');
    const d = await response.json();
    const url = new URL(d.graphql_api);
    if(url.protocol !== 'https:') throw Error('Invalid secure customer API');
    apiEndpoint = url.href;
    return apiEndpoint;
  }
  async function graphql(query,variables) {
    const auth = session();
    if (!auth) throw new Error('Sign in to MY RAVIN first');
    const api = await endpoint();
    const response = await fetch(api,{
      method:'POST',
      credentials:'omit',
      cache:'no-store',
      headers:{'Content-Type':'application/json','Authorization':auth.access},
      body:JSON.stringify({query,variables:variables || {}})
    });
    if (response.status===401 || response.status===403) throw new Error('Your account session needs reconnecting');
    if (!response.ok) throw new Error('Could not reach your saved edit');
    const data=await response.json();
    if (data.errors?.length) throw new Error(data.errors.map(e=>e.message).join('; ').slice(0,280));
    return data.data;
  }
  async function readCloud() {
    const data = await graphql(API_QUERY);
    const ownerId = data?.customer?.id;
    if (!ownerId) throw new Error('Could not verify your customer identity');
    return {ownerId,items:parseSaved(data.customer.metafield?.value)};
  }
  async function saveCloud(ownerId,items) {
    const value = JSON.stringify({version:1,items:items.slice(0,150)});
    if(value.length > 110000) throw Error('Your saved edit is too large');
    const data = await graphql(API_MUTATION,{metafields:[{ownerId,namespace:'custom',key:'ravin_wishlist',type:'json',value}]});
    const result = data?.metafieldsSet;
    if (!result || result.userErrors?.length) {
      throw new Error(result?.userErrors?.map(x=>x.message).join('; ') || 'Wishlist save is not permitted by this customer account');
    }
    const applied = result.metafields?.find(x=>x?.key === 'ravin_wishlist');
    if(!applied) throw new Error('Wishlist save could not be confirmed');
    const confirmed=parseSaved(applied.value);
    if(JSON.stringify(confirmed)!==JSON.stringify(parseSaved(value))) throw new Error('Saved wishlist did not match the requested changes');
    return confirmed;
  }
  function toast(text) {
    document.querySelector('.rvw-toast')?.remove();
    const box = el('div','rvw-toast',text);
    box.setAttribute('role','status');
    document.body.appendChild(box);
    clearTimeout(toastTimer);
    toastTimer=setTimeout(()=>box.remove(),3600);
  }
  function pending() {
    try {
      const item=JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      if (!item || !validHandle(item.handle) || Date.now() - Number(item.pendingAt || 0) > 86400000) return null;
      return item;
    } catch (_) { return null; }
  }
  function queueForSignin(item) {
    sessionStorage.setItem(PENDING_KEY,JSON.stringify({...item,pendingAt:Date.now()}));
  }
  function itemFromProduct() {
    if (!PRODUCT) return null;
    const handle=PRODUCT.dataset.rvwHandle;
    if (!validHandle(handle)) return null;
    const selected=document.querySelector('[data-ravin-pdp-editorial] input[data-variant-id]') ||
      document.querySelector('[data-ravin-pdp-editorial] form[data-product-form] input[name="id"]');
    return {
      handle,
      variantId:String(selected?.value || PRODUCT.dataset.rvwVariant || ''),
      title:PRODUCT.dataset.rvwTitle || '',
      image:PRODUCT.dataset.rvwImage || '',
      savedAt:new Date().toISOString()
    };
  }
  function popHeart() {
    if(!heart)return;
    heart.classList.remove('is-popping');
    void heart.offsetWidth;
    heart.classList.add('is-popping');
    setTimeout(()=>heart?.classList.remove('is-popping'),500);
  }
  function updateHeart(saved) {
    if (!heart) return;
    heart.setAttribute('aria-pressed',String(Boolean(saved)));
    const label = saved ? tr('Remove from MY RAVIN wishlist','شيل من المفضلة في ريفين') : tr('Save to MY RAVIN wishlist','احفظ في المفضلة في ريفين');
    heart.setAttribute('aria-label',label);
    const text=heart.querySelector('.rvw-heart__label');
    if(text)text.textContent=label;
  }
  function signInDialog() {
    let dialog=document.querySelector('[data-rvw-login-dialog]');
    if (!dialog) {
      dialog=el('dialog','rvw-dialog');
      dialog.setAttribute('data-rvw-login-dialog','');
      dialog.dir=isAr?'rtl':'ltr';
      const close=el('button','rvw-dialog__close','×');
      close.type='button';
      close.setAttribute('aria-label',tr('Close','إغلاق'));
      close.addEventListener('click',()=>dialog.close());
      const over=el('p','rvw-dialog__overline','RAVIN / SAVED EDIT');
      const title=el('h2','',tr('LOVE IT? MAKE IT OFFICIAL.','عجبك؟ خليه عندك بجد.'));
      const explanation=el('p','',tr('Connect MY RAVIN to keep this piece saved for months — across devices. No temporary browser wishlist.','اربط حسابك في ريفين عشان تلاقي القطعة حتى بعد شهور ومن أي جهاز.'));
      const button=el('button','rvw-dialog__cta',tr('CONNECT & SAVE MY PIECE ↗','سجّل الدخول واحفظ القطعة ↗'));
      button.type='button';
      button.addEventListener('click',()=>{
        const item=itemFromProduct();
        if(!item)return;
        queueForSignin(item);
        location.assign(PROFILE_URL);
      });
      dialog.append(close,over,title,explanation,button);
      document.body.appendChild(dialog);
    }
    if(typeof dialog.showModal==='function')dialog.showModal();
    else location.assign(PROFILE_URL);
  }
  async function clickHeart() {
    if (busy) return;
    const item=itemFromProduct();
    if(!item)return;
    popHeart();
    if (!session()) {
      if (!restoreForProduct(item)) signInDialog();
      return;
    }
    busy=true;
    heart.disabled=true;
    try {
      const current=await readCloud();
      const already=current.items.some(x=>x.handle===item.handle);
      const next=already ? current.items.filter(x=>x.handle!==item.handle) :
        [item,...current.items.filter(x=>x.handle!==item.handle)].slice(0,150);
      const stored=await saveCloud(current.ownerId,next);
      const nowSaved=stored.some(x=>x.handle===item.handle);
      updateHeart(nowSaved);
      popHeart();
      toast(nowSaved ? tr('SAVED TO MY RAVIN ♥','اتحفظت في مفضلة ريفين ♥') : tr('REMOVED FROM SAVED EDIT','اتشالت من المفضلة'));
    } catch(e) {
      if (/session needs reconnecting|sign in to MY RAVIN first/i.test(e.message||'') && restoreForProduct(item)) return;
      toast(tr('Could not save. Please reconnect in MY RAVIN.','معرفناش نحفظ. جرّب تربط حسابك في ريفين تاني.'));
      console.warn('RAVIN wishlist persistence:',e.message);
    } finally { busy=false;heart.disabled=false; }
  }
  async function initHeart() {
    if(!PRODUCT)return;
    const heading=document.querySelector('[data-ravin-pdp-editorial] .rpa-pdp-purchase-controls .rpa-pdp-price-kicker');
    if(!heading)return;
    const btn=el('button','rvw-heart');
    btn.type='button';
    btn.setAttribute('aria-pressed','false');
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24');
    svg.setAttribute('aria-hidden','true');
    const path=document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d','M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z');
    svg.appendChild(path);
    btn.append(svg,el('span','rvw-heart__label'));
    heading.appendChild(btn);
    heart=btn;
    updateHeart(false);
    btn.addEventListener('click',clickHeart);
    if(session()){
      try {
        const cloud=await readCloud();
        updateHeart(cloud.items.some(x=>x.handle===PRODUCT.dataset.rvwHandle));
      }catch(e){console.warn('RAVIN wishlist initial load:',e.message);}
    }
  }
  function state(title,details,action) {
    if(!ROOT)return;
    const box=ROOT.querySelector('[data-rvw-state]');
    const grid=ROOT.querySelector('[data-rvw-grid]');
    grid.hidden=true;
    box.hidden=false;
    box.replaceChildren(el('h3','',title),el('p','',details));
    if(action){
      const button=el('button','',action);
      button.type='button';
      button.addEventListener('click',()=>{
        const authButton=document.querySelector('[data-rva-auth-start]');
        if(authButton && !authButton.hidden){ authButton.click(); return; }
        document.querySelector('[data-rva-auth-panel]')?.scrollIntoView({behavior:'smooth',block:'center'});
      });
      box.append(button);
    }
  }
  const sass=[
    {en:'YOU LOVED IT. YOU SAVED IT. YOU DID NOTHING. 💀',ar:'عجبك. حفظته. اتفرجت عليه. وراح عليك. 💀'},
    {en:'SOLD OUT. EVEN THE MANNEQUIN MOVED ON.',ar:'خلص. حتى المانيكان فقد الأمل فيك.'},
    {en:'YOU WERE WAITING FOR A SIGN. THIS WASN’T IT.',ar:'كنت مستني إشارة؟ للأسف دي مش هي.'}
  ];
  function savedDays(iso) {
    const when=Date.parse(iso);
    return Number.isFinite(when) ? Math.max(0,Math.floor((Date.now()-when)/86400000)) : 0;
  }
  async function productData(handle) {
    const response=await fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
    if(!response.ok) return null;
    try {return await response.json();}catch(_){return null;}
  }
  function pricingSettings() {
    try {return JSON.parse(document.getElementById('rvw-pricing-data')?.textContent || '{}');}catch(_){return {};}
  }
  function livePrice(prod,variant) {
    if(!variant || !Number.isFinite(Number(variant.price))) return '';
    const opts=pricingSettings();
    let amount=Number(variant.price);
    if(opts.enabled){
      const tags=Array.isArray(prod?.tags) ? prod.tags : String(prod?.tags || '').split(',');
      const normalized=tags.map(x=>String(x).trim().toLowerCase());
      let pct=Number(opts.fallback)||0;
      for(let i=1;i<=4;i++){
        const candidates=String(opts['group'+i+'Tags']||'').split(',').map(x=>x.trim().toLowerCase()).filter(Boolean);
        if(candidates.some(t=>normalized.includes(t))){pct=Number(opts['group'+i+'Percent'])||0;break;}
      }
      amount=Math.round(amount*(100-Math.max(0,Math.min(100,pct)))/100);
    }
    const code=opts.currency||'EGP';
    return new Intl.NumberFormat(isAr?'ar-EG':'en-EG',{style:'currency',currency:code}).format(amount/100);
  }
  function createCard(item,live,index) {
    const variants=Array.isArray(live?.variants)?live.variants:[];
    const requested=variants.find(v=>String(v.id)===String(item.variantId));
    const inStock=Boolean(requested?.available);
    const allGone=live===null || !Boolean(live.available) || !variants.some(v=>v.available);
    const out=!inStock;
    const card=el('article','rvw-piece');
    card.dataset.soldout=String(out);
    const path='/products/'+encodeURIComponent(item.handle);
    const imageLink=el('a','rvw-piece__media');
    imageLink.href=path+(requested?'?variant='+encodeURIComponent(requested.id):'');
    const img=el('img');
    img.loading='lazy';
    img.decoding='async';
    img.alt=live?.title||item.title;
    const liveImg=typeof live?.featured_image === 'string' ? live.featured_image : Array.isArray(live?.images) ? live.images[0] : '';
    const url=safeImage(liveImg)||safeImage(item.image);
    if(url)img.src=url;
    imageLink.appendChild(img);
    if(out)imageLink.appendChild(el('span','rvw-piece__badge',allGone?tr('SOLD OUT','خلصت'):tr('SAVED SIZE SOLD OUT','مقاسك خلص')));
    const content=el('div','rvw-piece__body');
    const title=el('h3','rvw-piece__title',live?.title || item.title || tr('RAVIN piece','قطعة ريفين'));
    content.appendChild(title);
    if(!out){
      const price=livePrice(live,requested);
      if(price)content.appendChild(el('div','rvw-piece__meta',price + tr(' · promotional estimate',' · سعر تقريبي بعد العرض')));
    }
    if(requested && requested.title && requested.title.toUpperCase()!=='DEF' && requested.title!=='Default Title') {
      content.appendChild(el('div','rvw-piece__meta',tr('Saved option: ','الموديل المحفوظ: ')+requested.title));
    }
    content.appendChild(el('div','rvw-piece__meta',tr('Saved ','محفوظة من ')+new Date(item.savedAt).toLocaleDateString(isAr?'ar-EG':'en-EG')));
    if(out){
      const roast=sass[index % sass.length];
      content.appendChild(el('p','rvw-piece__roast',allGone?tr(roast.en,roast.ar):tr('YOUR SIZE LEFT THE CHAT. 💀','مقاسك ساب الشات. 💀')));
      content.appendChild(el('p','rvw-piece__meta',tr('Your wishlist was never a reservation, bestie.','المفضلة مش حجز يا نجم.')));
    }else if(savedDays(item.savedAt)>30){
      content.appendChild(el('p','rvw-piece__meta',tr('Saved for '+savedDays(item.savedAt)+' days. Commitment issues?','بقالك '+savedDays(item.savedAt)+' يوم بتفكر فيها. هتقرر إمتى؟')));
    }
    const actions=el('div','rvw-piece__actions');
    if (!out && requested && Number.isSafeInteger(Number(requested.id))) {
      const add=el('button','rvw-piece__cta',tr('ADD SAVED SIZE +','ضيف المقاس للسلة +'));
      add.type='button';
      add.addEventListener('click',async()=>{
        if(add.disabled)return;
        add.disabled=true;
        const oldLabel=add.textContent;
        add.textContent=tr('ADDING…','بنضيف…');
        try {
          const res=await fetch((window.routes?.cart_add_url||'/cart/add')+'.js',{
            method:'POST',
            credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({id:Number(requested.id),quantity:1})
          });
          if(!res.ok)throw Error('Unable to add the selected variant');
          location.assign(window.routes?.cart_url||'/cart');
        }catch(e){
          toast(tr('Could not add this size. Please try the product page.','مش قادرين نضيف المقاس. افتح صفحة المنتج وجرب.'));
          add.disabled=false;
          add.textContent=oldLabel;
        }
      });
      actions.appendChild(add);
    }
    const visit=el('a','rvw-piece__cta',out?tr('FIND SIMILAR ↗','شوف شبهها ↗'):tr('VIEW PRODUCT ↗','شوف المنتج ↗'));
    visit.href=out?'/search?q='+encodeURIComponent((live?.title||item.title||'RAVIN').split(/\s+/).slice(0,2).join(' '))+'&type=product':imageLink.href;
    const remove=el('button','rvw-piece__remove',tr('REMOVE','إزالة'));
    remove.type='button';
    remove.setAttribute('aria-label',tr('Remove from wishlist','شيل من المفضلة')+' '+(live?.title||item.title));
    remove.addEventListener('click',async()=>{
      if(busy)return;
      busy=true;remove.disabled=true;
      try{
        const current=await readCloud();
        await saveCloud(current.ownerId,current.items.filter(x=>x.handle!==item.handle));
        toast(tr('REMOVED FROM SAVED EDIT','اتشالت من المفضلة'));
        await renderAccount();
      }catch(e){
        toast(tr('Could not remove. Please try again.','معرفناش نمسحها، جرّب تاني.'));
        console.warn('RAVIN wishlist remove:',e.message);
        remove.disabled=false;
      }finally{busy=false;}
    });
    actions.append(visit,remove);
    content.append(actions);
    card.append(imageLink,content);
    return card;
  }
  function updateDashboardCount(count) {
    const badge=document.querySelector('[data-rva-wishlist-count]');
    if(!badge)return;
    if(!Number.isInteger(count)||count<0){badge.hidden=true;return;}
    badge.textContent=String(count);
    badge.hidden=false;
  }
  async function renderAccount() {
    if(!ROOT)return;
    const task=++accountLoadCounter;
    if(!session()) {
      updateDashboardCount(null);
      state(tr('YOUR EDIT NEEDS YOUR ACCOUNT.','مفضلتك محتاجة حسابك.'),
        pending()?tr('Your selected piece is waiting. Connect MY RAVIN to save it permanently.','القطعة اللي اخترتها مستنياك. اربط حسابك عشان تتحفظ بجد.'):tr('Connect MY RAVIN to see pieces saved across visits and devices.','اربط حسابك في ريفين عشان تشوف القطع المحفوظة من أي جهاز.'),
        tr('CONNECT MY ACCOUNT ↗','اربط حسابي ↗'));
      return;
    }
    state(tr('OPENING YOUR SAVED EDIT…','بنفتح مفضلتك…'),tr('Reading your saved pieces securely from your Shopify account.','بنجيب القطع المحفوظة من حسابك بأمان.'));
    try {
      let cloud=await readCloud();
      const intent=pending();
      if(intent && !cloud.items.some(x=>x.handle===intent.handle)) {
        const {pendingAt,...item}=intent;
        const next=[item,...cloud.items].slice(0,150);
        await saveCloud(cloud.ownerId,next);
        cloud={ownerId:cloud.ownerId,items:next};
        sessionStorage.removeItem(PENDING_KEY);
        toast(tr('YOUR PIECE IS SAVED TO MY RAVIN ♥','القطعة اتحفظت في مفضلة ريفين ♥'));
      }else if(intent){sessionStorage.removeItem(PENDING_KEY);}
      if(task!==accountLoadCounter)return;
      updateDashboardCount(cloud.items.length);
      if(!cloud.items.length){
        state(tr('NOTHING SAVED. YET.','لسه مفيش حاجات محفوظة.'),
          tr('Your next favorite is out there. Save it with the lime heart on the product page.','لما تعجبك قطعة دوس على القلب الأخضر في صفحة المنتج.'),
          null);
        return;
      }
      const results=await Promise.all(cloud.items.slice(0,60).map(async item=>({item,live:await productData(item.handle).catch(()=>null)})));
      if(task!==accountLoadCounter)return;
      const grid=ROOT.querySelector('[data-rvw-grid]');
      grid.replaceChildren(...results.map(({item,live},i)=>createCard(item,live,i)));
      grid.hidden=false;
      ROOT.querySelector('[data-rvw-state]').hidden=true;
    }catch(e){
      updateDashboardCount(null);
      console.warn('RAVIN wishlist account:',e.message);
      state(tr('WE COULDN’T OPEN YOUR SAVED EDIT.','مش قادرين نفتح مفضلتك.'),
        tr('Reconnect MY RAVIN or retry. Nothing has been erased.','جرّب تربط الحساب تاني. مفيش حاجة اتحذفت.'),
        tr('RECONNECT ACCOUNT ↗','اربط الحساب تاني ↗'));
    }
  }
  function run() {
    if(PRODUCT) initHeart();
    if(ROOT){
      window.addEventListener('ravin:account-ready',renderAccount);
      renderAccount();
      window.addEventListener('pageshow',renderAccount);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();